// Keep the operational navigation available while Slack is the primary work surface.
export const OPERATOR_ADMIN_NAVIGATION_ENABLED = true;

export const OPERATOR_CONTENT_COLUMN_CLASS_NAME = "mx-auto w-full max-w-2xl";

// Chat owns its horizontal gutters, so its outer width includes them while the
// visible message and composer column remains the same width as other pages.
export const OPERATOR_PADDED_CONTENT_COLUMN_CLASS_NAME =
  "mx-auto w-full max-w-[calc(42rem+2.5rem)] px-5 sm:max-w-[calc(42rem+4rem)] sm:px-8";

export const OPERATOR_WORKSPACE_FRAME_CLASS_NAME =
  "relative flex h-dvh min-h-0 w-full overflow-hidden bg-background font-sans text-foreground [--sidebar-foreground:#081643] [--sidebar-muted-foreground:#777773] [--sidebar-row-active:#FDFDFF] [--sidebar-row-hover:rgb(255_255_255/0.6)] [--sidebar:transparent] [background-image:var(--workspace-background)]";
export const OPERATOR_WORKSPACE_PANE_CLASS_NAME =
  "m-2 flex min-h-0 min-w-0 flex-1 flex-col max-sm:absolute max-sm:inset-y-0 max-sm:left-0 max-sm:w-[calc(100%-1rem)] max-sm:transition-transform max-sm:duration-200 max-sm:ease-[cubic-bezier(0.23,1,0.32,1)] motion-reduce:transition-none";
export const OPERATOR_WORKSPACE_SIDEBAR_CLASS_NAME =
  "flex h-full w-[240px] shrink-0 flex-col bg-transparent text-sidebar-foreground";
